<div class="inspection-row">
    <div class="date-section">
        <mat-icon class="calendar-icon">calendar_today</mat-icon>
        <span class="date-text">{{ inspection.inspectionDate | localeDate:'mediumDate' }}</span>
        <ng-container>
            <app-custom-popover [index]="inspection.id" title="pages.inspectionItem.notes" [content]="inspection.notes"
                                noContentMessage="pages.inspectionItem.no_notes"></app-custom-popover>
        </ng-container>
    </div>

    <!-- Different display based on calculation status -->
    <ng-container *ngIf="isCalculationFailed(); else normalDisplay">
        <!-- Error display when calculation failed -->
        <div class="error-section">
            <div class="error-message">
                <mat-icon class="error-icon">error</mat-icon>
                <span>{{ 'pages.inspectionItem.calculation_failed' | translate }}</span>
            </div>
            <button mat-flat-button color="warn" class="retry-button" (click)="onRefreshCalculation()">
                <mat-icon>refresh</mat-icon>
                {{ 'pages.inspectionItem.retry_calculation' | translate }}
            </button>
        </div>
    </ng-container>

    <ng-template #normalDisplay>
        <div class="recommendation-pill" [ngClass]="getRecommendationClass()" *ngIf="isCalculationCompleted() else spinner">
            {{ 'ffsRecommendationCode.' + inspection.result.ffsRecommendationCode | translate }}
        </div>

        <div class="metrics-section">
            <!-- Première colonne: toujours présente mais contenu conditionnel -->
            <div class="metric-column">
                <div class="metric forced-cr" *ngIf="inspection.result?.forcedCorrosionRate && isCalculationCompleted()">
                    <mat-label class="metric-label">{{ 'pages.inspectionItem.forced_cr' | translate }}</mat-label>
                    <div class="metric-value">{{ inspection.result.forcedCorrosionRate | localeDecimal }} mm/yr.</div>
                </div>
                <!-- Pas de contenu alternatif ici - l'espace est préservé par la colonne -->
            </div>

            <!-- Deuxième colonne: stat CR -->
            <div class="metric-column">
                <div class="metric">
                    <mat-label class="metric-label">{{ 'pages.inspectionItem.stat_cr' | translate }}</mat-label>
                    <div class="metric-value" *ngIf="isCalculationCompleted() else spinner">
                        {{ inspection.result.statCorrosionRate | localeDecimal }} mm/yr.
                    </div>
                </div>
            </div>

            <!-- Troisième colonne: expected min thick -->
            <div class="metric-column">
                <div class="metric">
                    <mat-label class="metric-label">{{ "pages.inspectionItem.expected_min_thick" | translate }}</mat-label>
                    <div class="metric-value" *ngIf="isCalculationCompleted() else spinner">
                        {{ inspection.result.minThicknessExtrapolated | localeDecimal }} mm
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <button mat-icon-button class="edit-button" (click)="onEditInspection()" [disabled]="!isCalculationCompleted()">
        <mat-icon svgIcon="total-edit">edit</mat-icon>
    </button>

</div>

<div *ngIf="inspection.result?.lastCalculatedAt && inspection.result?.lastCalculatedBy" class="last-updated">
    {{ 'pages.inspectionItem.last_update' | translate }}:  {{ inspection.result.lastCalculatedAt | localeDate:'mediumDate' }}
    {{ 'pages.inspectionItem.by' | translate }} {{ inspection.result.lastCalculatedBy.firstName }} {{ inspection.result.lastCalculatedBy.lastName }}
</div>

<ng-template #spinner>
    <app-custom-spinner></app-custom-spinner>
</ng-template>
